var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-detail-wrap",class:{'mobile': _vm._isMobile}},[_c('div',{staticClass:"cmp-detail"},[(!_vm.hideName)?_c('h1',{staticClass:"g-title-1"},[_vm._v(_vm._s(_vm.detailData.name))]):_vm._e(),_c('div',{staticClass:"g-detail-html trans",domProps:{"innerHTML":_vm._s(_vm.detailData.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }